const formatProductData = (product, index = 0) => ({
  availability: product.availableForSale,
  collections: product.collections.edges.map(
    (collection) => collection.node.title,
  ),
  handle: product.handle,
  index,
  item_brand: product.vendor,
  item_id: product.variants[0].sku,
  item_name: `${product.title} - ${product.variants[0].title}`,
  item_variant: product.variants[0].title,
  item_variant_internal_id: Number(
    product.variants[0].id.split('gid://shopify/ProductVariant/')[1],
  ),
  parent_internal_id: Number(product.id.split('gid://shopify/Product/')[1]),
  parent_item_name: product.title,
  parent_item_sku: product.variants[0].sku,
  price: parseInt(product.priceRange.minVariantPrice.amount, 10),
  product_type: product.productType,
});

const formatVariantData = (variant, product) => {
  const { title, sku, id } = variant;
  return {
    availability: product.availableForSale,
    collections: product.collections.edges.map(
      (collection) => collection.node.title,
    ),
    handle: product.handle,
    item_brand: product.vendor,
    item_id: sku,
    item_name: `${product.title} - ${title}`,
    item_variant: title,
    item_variant_internal_id: Number(
      id.split('gid://shopify/ProductVariant/')[1],
    ),
    parent_internal_id: Number(product.id.split('gid://shopify/Product/')[1]),
    parent_item_name: product.title,
    parent_item_sku: sku,
    price: parseInt(variant.price.amount, 10),
    product_type: product.productType,
  };
};

export { formatProductData, formatVariantData };
